<template>
  <div
    :class="[
      'pdf-controls d-flex flex-column align-items-center justify-content-center',
      buttonsPosition,
    ]"
  >
    <div class="buttons-container">
      <div
        :class="{ focus: doubleButtonFocus }"
        class="double-button d-flex flex-column align-items-center i-radius-md i-mb-2 i-gap-1"
      >
        <i-button
          id="zoom-in"
          class="top"
          :disabled="value === maxZoom"
          left-icon="medium-add-1"
          :type="iButtonTypes.NEUTRAL"
          :button-style="iButtonStyles.GHOST"
          :size="iButtonSizes.SMALL"
          @button-click="changeZoomFactor(zoomStep)"
          @focus="doubleButtonFocus = true"
          @blur="doubleButtonFocus = false"
        >
        </i-button>
        <i-tooltip
          target="#zoom-in"
          title="Zoom in"
          :alignment="iTooltipAlignmentMode.LEFT_MIDDLE"
        />
        <i-button
          id="zoom-out"
          class="bottom"
          :disabled="value === minZoom"
          :type="iButtonTypes.NEUTRAL"
          :button-style="iButtonStyles.GHOST"
          :size="iButtonSizes.SMALL"
          left-icon="medium-remove-1"
          @focus="doubleButtonFocus = true"
          @blur="doubleButtonFocus = false"
          @button-click="changeZoomFactor(-1 * zoomStep)"
        >
        </i-button>
        <i-tooltip
          target="#zoom-out"
          title="Zoom out"
          :alignment="iTooltipAlignmentMode.LEFT_MIDDLE"
        />
      </div>
      <slot name="extra-buttons"> </slot>
    </div>
  </div>
</template>

<script>
import {
  iButton,
  iButtonStyles,
  iButtonTypes,
  iButtonSizes,
  iTooltip,
  iTooltipAlignmentMode,
} from '@inscribe/signal';

export default {
  components: {
    iButton,
    iTooltip,
  },
  props: {
    initialFit: {
      type: String,
      default: 'width',
    },
    buttonsPosition: {
      type: String,
      default: 'bottom',
    },
    minZoom: {
      type: Number,
      default: 0.75,
    },
    maxZoom: {
      type: Number,
      default: 10,
    },
    value: {
      type: Number,
      required: true,
    },
    zoomStep: {
      type: Number,
      default: 0.25,
    },
  },
  data() {
    return {
      fit: this.initialFit,
      doubleButtonFocus: false,
      iButtonTypes,
      iButtonStyles,
      iButtonSizes,
      iTooltipAlignmentMode,
    };
  },
  methods: {
    changeZoomFactor(increment) {
      this.$emit('input', increment);
    },
  },
};
</script>

<style lang="scss">
.pdf-controls {
  width: 44px;

  .double-button {
    padding: 2px;
    border: 1px solid $light-neutral-60;
    background: $white-base;

    button {
      border: 0;
      box-shadow: none;

      &:hover {
        background: $light-neutral-30;
      }

      &.top {
        z-index: 0;

        &:hover {
          z-index: 10;
        }
      }

      &.bottom {
        z-index: 0;

        &:hover {
          z-index: 10;
        }
      }
    }
  }

  .vue-slider .vue-slider-rail {
    background: $color-dark-blue-40;

    .vue-slider-process {
      background: $color-dark-blue-80;
    }
  }
}
</style>
